/* Global Transforms */
import { transformNavigationFooter } from '../blocks/navigation-footer/NavigationFooter.transform.wp';
import { transformNavigationMain } from '../blocks/navigation-main/NavigationMain.transform.wp';
// import { transformNotificationBar } from "../blocks/notification-bar/NotificationBar.transform.wp";
import { transformHeroCtaFallback } from '../blocks/hero-cta/HeroCta.transform.wp';
import { transformHeroHomeGlobal } from '../blocks/hero-home/HeroHome.transform.wp';

export function transformGlobalData(data) {
  if (!data) return null;

  // console.log("global data", data);

  return {
    navigationFooter: transformNavigationFooter(data),
    navigationMain: transformNavigationMain(data),
    heroCtaFallback: transformHeroCtaFallback(data),
    // Homepage hero's HLS manifest, so any page can warm it before a
    // client-side navigation to "/". Null when the homepage has no hero video.
    homeHeroVideoUrl: transformHeroHomeGlobal(data),
    // notificationBar: transformNotificationBar(data),
  };
}
